import { render, staticRenderFns } from "./crmchannelinfo.vue?vue&type=template&id=1f4c40eb&scoped=true&"
import script from "./crmchannelinfo.vue?vue&type=script&lang=js&"
export * from "./crmchannelinfo.vue?vue&type=script&lang=js&"
import style0 from "./crmchannelinfo.vue?vue&type=style&index=0&id=1f4c40eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c40eb",
  null
  
)

export default component.exports